export default __webpack_public_path__ + "static/media/paper-shredder.37aa9948.png";